import type { Contest } from '~/domains/contest/domains/services/interfaces/contest.interface';
import { Table } from '~/domains/design-system/components/Table/Table';
import type { TableProps } from '~/domains/design-system/components/Table/Table';

import useStyles from './styles';
import useTableLobby from './useTableLobby';

interface TableLobbyProps {
  data: Contest[];
  isLoading: boolean;
  pagination: TableProps['pagination']
}

function TableLobby({ data, isLoading, pagination }: TableLobbyProps) {
  const { classes } = useStyles();
  const { columnHeaders, rows, cellStyles } = useTableLobby(data);

  return (
    <Table
      className={classes.lobbyTable}
      // @TODO: Fix the table columnHeaders sort direction type
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      columnHeaders={columnHeaders}
      cellStyles={cellStyles}
      rows={rows}
      isLoading={isLoading}
      pagination={pagination}
    />
  );
}

export default TableLobby;
